import { useForm } from "react-hook-form";
import LoginForm from "src/toolkit/forms/LoginForm";
import useConstraints from "src/toolkit/forms/useConstraints";
import { yupResolver } from "@hookform/resolvers/yup";
import { useAuth } from 'src/toolkit/services/AuthProvider';
import { useStore } from 'src/integration/store/store';

const useLoginForm = () => {
    const { loginSchema } = useConstraints();
    const auth = useAuth();
    const { configStore } = useStore();
    const { setPassword, setEmail } = configStore;

    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm<LoginForm>({ resolver: yupResolver(loginSchema) });

    const handleFormSubmission = handleSubmit((data) => {
        if (data.username !== "" && data.password !== "") {
            setPassword(data.password);
            setEmail(data.username);
            return auth.loginAction();
        }
    });

    return {
        register,
        errors,
        isLoading: auth.isFetching,
        handleFormSubmission,
        loginError: auth.loginError,
    }
}

export default useLoginForm;